import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchOnlineVisitors, addVisitor } from "../features/track/trackSlice";
import trackService from "../features/track/trackService";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "../styles/onlineVisitors.css";

// Leaflet icon fix
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png",
  iconUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
  shadowUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
});

// Custom flag marker
const createFlagIcon = (emoji) => {
  return new L.DivIcon({
    html: `<div style="font-size:24px;">${emoji}</div>`,
    className: "",
    iconSize: [30, 30],
    iconAnchor: [15, 30],
  });
};

const OnlineVisitors = () => {
  const dispatch = useDispatch();
  const { visitors, count, isLoading } = useSelector((state) => state.track);
 console.log(visitors,"visitors")
  useEffect(() => {
    dispatch(fetchOnlineVisitors());

    const socket = trackService.initSocket((visitor) => {
      dispatch(addVisitor(visitor));
    });

    return () => {
      trackService.disconnectSocket();
    };
  }, [dispatch]);

  // Default center if no visitors
  const defaultCenter = [0, 0];
  const center =
    visitors.length > 0
      ? [visitors[0].latitude || 0, visitors[0].longitude || 0]
      : defaultCenter;

    const googlePin = new L.Icon({
  iconUrl:
    "https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi-dotless_hdpi.png",
  iconSize: [20, 30],
  iconAnchor: [15, 40],
});


  return (
    <div className="online-visitors-container">
      <h2>Online Visitors ({count})</h2>

      {isLoading && <p>Loading...</p>}

      <table className="visitor-table">
        <thead>
          <tr>
            <th>Flag</th>
            <th>Location</th>
            <th>IP</th>
          </tr>
        </thead>
        <tbody>
          {visitors.map((v) => (
            <tr key={v._id}>
              <td>{v.countryFlagEmoj}</td>
              <td>
                {v.city}, {v.countryName}
              </td>
              <td>{v.ip}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Map showing all visitors */}
      <div style={{ marginTop: "20px" }}>
        <MapContainer
          center={center}
          zoom={2}
          scrollWheelZoom={false}
          style={{ height: "500px", width: "100%" }}
        >
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
{visitors.map((v) =>
  v.latitude != null && v.longitude != null ? (
<div style={{ marginTop: "20px" }}>
  <MapContainer
    center={center}
    zoom={20}
    scrollWheelZoom={true}
    style={{ height: "500px", width: "100%" }}
  >
    <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

    {visitors.map((v) =>
      v.latitude != null && v.longitude != null ? (
        <Marker
          key={v._id}
          position={[v.latitude, v.longitude]}
          icon={googlePin}   // <—— GOOGLE PIN HERE
        >
          <Popup>
            <strong>
              {v.city}, {v.countryName}
            </strong>
            <br />
            IP: {v.ip}
            <br />
            Lat: {v.latitude}, Lng: {v.longitude}
            <br />
            User Agent: {v.userAgent?.slice(0, 40)}...
          </Popup>
        </Marker>
      ) : null
    )}
  </MapContainer>
</div>

  ) : null
)}

        </MapContainer>
      </div>
    </div>
  );
};

export default OnlineVisitors;
